export const percentageDifference = (initialValue: number, finalValue: number): number => {
    if (initialValue === 0 && finalValue === 0) return 0;
    if (initialValue === 0) return 100;
    return ((finalValue - initialValue) / initialValue) * 100;
};

export const percentagePointDifference = (initialValue: number, finalValue: number) => finalValue - initialValue;
